<template>
    <div>
        <div class="dh_p1a w-100">
            <div class="x_div_center" style="height:100%; background-color:rgba(0, 0, 0, 0.3);">
                <div class="rp_set px-3" style="padding:120px 0 0 0;">
                    <span class="dh_p1b">인재채용</span><br>
                    <span class="dh_p1c">M3의 인재채용 소식을 알려 드립니다.</span>
                </div>
            </div>
        </div>

        <div class="x_div_center">
            <div class="rp_set" style="border:0px solid red">

                <!-- 인재채용 -->
                <div class="py-3 pt-5">
                    <div class="x_div_left"><span class="fkr-set2 fs-16 fc-w11"><strong>함께 성장할 New Crew를 찾고 있습니다!
                            </strong></span></div>

                    <div class="x_div_left px-3 py-2" style="line-height: 180%; color: #555;">
                        <p style="margin: 8px 0;">첨단 BIM 통합형 DfMA 기술을 보유한 모듈러 건축 통합플랫폼 서비스 제공 및 프리미엄 모듈러 건축물을 만드는 기업,
                            <strong>M3 Systems</strong> 입니다 :)
                        </p>
                        <p style="margin: 8px 0;"><strong>다음과 같은 분을 환영합니다!</strong></p>
                        <ul style="margin: 8px 0 8px 20px; padding: 0;">
                            <li>건설 플랫폼/제조화 스타트업의 멤버로 합류하여 회사의 일하는 문화를 함께 만들어나가고 싶으신 분</li>
                            <li>그러한 열정을 가지고 모인 사람들과 함께 재미있게 일해보고 싶은 분</li>
                            <li>사람을 소중하게 생각하는, 서로 존중하는 분위기의 회사에서 일하고 싶은 분</li>
                            <li>빠르게 성장하는 회사에서 A부터 Z까지 만들어내는 커리어와 성취감을 경험하고 싶은 분</li>
                        </ul>
                    </div>

                    <div class="x_div_left px-3 py-2"><span class="fkr-set2 fs-13 fc-w10"><strong>[모집부문 및
                                자격요건]</strong></span></div>

                    <!-- 모집부문 -->
                    <div>
                        <div class="table-responsive" style="border:1px solid #c9c9c9; border-radius:8px">
                            <table class="table-borderless w-100" style="table-layout:fixed">
                                <tr style="height:55px;">
                                    <td class="text-center br_0" width="200" style="background-color:#4e0000"><span
                                            class="fkr-set1 fs-095 fc-w1">모집부문</span></td>
                                    <td class="text-center br_0" width="370" style="background-color:#4e0000"><span
                                            class="fkr-set1 fs-095 fc-w1">담당업무</span></td>
                                    <td class="text-center" width="600" style="background-color:#4e0000"><span
                                            class="fkr-set1 fs-095 fc-w1">자격요건 및 우대사항</span></td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">건축 코디네이터</span><br><br><span class="fkr-set1">경력
                                            채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>설계코디네이션(모듈러건축)</li>
                                            <ul style="margin:8px 0 0 12px; padding:0; padding-bottom:8px">
                                                <li>설계 및 인허가 프로세스 코디네이션</li>
                                                <li>모듈러 건축물 제조 관리</li>
                                            </ul>
                                            <li>기획설계, 실시설계</li>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>경력 3년 이상</li>
                                                <li>국내외 건축관련분야 학사 이상 학위 취득자</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>BIM 저작도구 사용 가능하신 분</li>
                                                <li>업무시설, 공동주택 설계 경험자 우대</li>
                                                <li>건축학과(5년제) 졸업자이신분</li>
                                                <li>건축 설계사무소 재직 경험있으신 분</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">영업</span><br><br><span class="fkr-set1">경력
                                            채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>고객 초기 대응(B2B, B2C, B2G)</li>
                                            <li>고객 상담</li>
                                            <li>도면 검토</li>
                                            <li>기획 설계</li>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>학력 무관</li>
                                                <li>건축 설계사무소 및 건설 관련 경력 5년 이상 경험해보신 분</li>
                                                <li>MS Office(엑셀 및 파워포인트 등 사무 자동화 프로그램 활용능력 보유 및 능숙하신 분)</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>(모듈러)설계 및 건축영업 유경험자</li>
                                                <li>부동산 시장에 대한 이해도가 높으신 분</li>
                                                <li>CAD/BIM 저작도구 활용 가능자</li>
                                                <li>컴퓨터활용능력 우수</li>
                                                <li>커뮤니케이션 및 협업 능력 우수하신 분</li>
                                                <li>성실하고 정확한 업무처리 능력을 바탕으로, 높은 책임감을 가지고 문제해결을 즐기시는 분</li>
                                                <li>운전 가능자</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">모듈러 생산</span><br><br><span class="fkr-set1">신입/경력
                                            채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>이천 공장 모듈 생산관리</li>
                                            <li>현장관리</li>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건 및 우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>일반 건축 및 모듈러 건축관련 전공자</li>
                                                <li>CAD 활용 가능자</li>
                                                <li>운전가능자 / 기흥과 이천 이동 근무 가능자</li>
                                                <li>모듈러 건축 현장 경험자</li>
                                                <li>건축현장 경험자</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">특이사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>주 6일 근무</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">공무</span><br><br><span class="fkr-set1">경력
                                            채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>프로젝트 별 실행 원가 관리</li>
                                            <li>각종 사무 문서 관리</li>
                                            <li>견적서 작성</li>
                                            <li>CAD 활용</li>
                                            <li>건축제조사업본부 사무 업무 지원</li>
                                            <li>고객 관리</li>
                                            <li>필요시 현장 확인</li>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>경력 3년 이상</li>
                                                <li>학력 무관</li>
                                                <li>MS Office(엑셀 및 파워포인트 등 사무자동화 프로그램 활용 능숙)</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>건설사 공무 경력 3년 이상 경험자</li>
                                                <li>컴퓨터 활용능력 우수</li>
                                                <li>커뮤니케이션 및 협업 능력 우수</li>
                                                <li>공무, 경리 경험 우대</li>
                                                <li>CAD 활용 가능자</li>
                                                <li>운전 가능자</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">연구개발</span><br><br><span class="fkr-set1">신입/경력
                                            채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>연구 분야 : 모듈러 건축 분야, BIM, 로봇서비스, <br>설계자동화 등</li>
                                            <li>관련 제안서 작성</li>
                                            <li>프로젝트 관리</li>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>경력 무관 (신입 지원 가능)</li>
                                                <li>대학교졸업(4년)이상, 졸업 예정자 지원가능</li>
                                                <li>국내•외 건축관련분야 학사/석사/박사학위 이상 취득(예정)자</li>
                                                <li>연구원 임용요건에 결격사유가 없는 자</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>스마트빌딩 / BIM / AI /로봇 자동화 제조 / 로봇서비스 관련 연구경력자 또는 실무경력자 우대</li>
                                                <li>국가R&D과제 경험자 우대(과제 관리)</li>
                                                <li>건축 혹은 토목 분야 전공자</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">마케팅/홍보</span><br><br><span class="fkr-set1">경력
                                            채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>마케팅 홍보</li>
                                            <li>M3 Systems 기술연구소 업무지원</li>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>학사이상</li>
                                                <li>마케팅 홍보 전반적 업무 가능자(유튜브, 인스타그램 등 SNS 홍보 및 동영상 편집 가능자)</li>
                                                <li>제조화건설 스타트업 초기 멤버로 의욕적으로 회사의 문화를 함께 만들어 가실 분</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>관련학과 졸업 및 유경험자</li>
                                                <li>건축 분야에 지식이 있거나 관심이 있으신 분</li>
                                                <li>미래 건설에 대한 열정이 높으신 분</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr style="border-bottom:1px solid #c9c9c9">
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">프론트엔드<br>엔지니어</span><br><br><span
                                            class="fkr-set1">신입/경력 채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>buildmarket.kr 플랫폼 웹 프론트엔드 개발 (○ 명)</li>
                                            <ul style="margin:8px 0 0 12px; padding:0">
                                                <li>건축물 라이프사이클 통합 웹 유지관리</li>
                                                <li>이해관계자 협업 기능 및 서비스 고도화</li>
                                            </ul>
                                            <li class="pt-2">로봇 관제 및 제어 솔루션 프론트엔드 개발 (○ 명)</li>
                                            <ul style="margin:8px 0 0 12px; padding:0">
                                                <li>다수/다종 건축물 내 서비스 로봇 관리 프론트 개발</li>
                                                <li>공장 내 건축물 제조 로봇을 관제 솔루션 개발</li>
                                            </ul>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>Vue 프레임워크 기반 프론트엔드 서버 개발 경험이 있으신 분</li>
                                                <li>HTML, CSS JavaScript 활용에 능숙하신 분</li>
                                                <li>반응형 웹 디자인에 대한 이해도가 높으신 분</li>
                                                <li>Git, Confluence등의 소스코드, 이슈 관리 소프트웨어를 사용한 적이 있으신 분</li>
                                                <li>스타트업 초기 멤버로 의욕적으로 회사의 문화를 함께 만들어 가실 분</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>전산 관련 학과 졸업 후 3년 이상 업계 근무 경력이 있으신 분</li>
                                                <li>JavaScript를 통한 3D 렌더링 지식이 있으신 분</li>
                                                <li>건축 분야에 지식이 있거나 관심이 있으신 분</li>
                                                <li>Container 기반 개발 환경 구성 경험이 있으신 분</li>
                                                <li>Kubernetes(K8s) 기반 서비스 배포 경험이 있으신 분</li>
                                                <li>지식을 팀원과 공유하는 것을 즐거워하시는 분</li>
                                                <li>전통적 기술부터 최신 기술까지 다양한 기술 습득을 목표로 하시는 분</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center br_0">
                                        <span class="fkr-set1 fc-w9">백엔드<br>엔지니어</span><br><br><span
                                            class="fkr-set1">신입/경력 채용<br>○ 명</span>
                                    </td>
                                    <td class="br_0 py-3 pe-2">
                                        <ul style="margin:0">
                                            <li>buildmarket.kr 플랫폼 백엔드 개발 (○ 명)</li>
                                            <ul style="margin:8px 0 0 12px; padding:0">
                                                <li>건축물 라이프사이클 통합 웹 유지관리</li>
                                                <li>이해관계자 협업 기능 및 서비스 고도화</li>
                                            </ul>
                                            <li class="pt-2">로봇 관제 및 제어 솔루션 백엔드 개발 (○ 명)</li>
                                            <ul style="margin:8px 0 0 12px; padding:0">
                                                <li>다수/다종 건축물 내 서비스 로봇 관리 프로세스 정의</li>
                                                <li>공장 내 건축물 제조 로봇을 관제 솔루션 연구개발</li>
                                            </ul>
                                        </ul>
                                    </td>
                                    <td class="py-3">
                                        <ol style="margin:0">
                                            <li><span class="fkr-set1">자격요건</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>백엔드 서버 개발 경험이 있으신 분</li>
                                                <li>Spring Boot 사용에 능숙하신 분</li>
                                                <li>RDB(PostgreSQL) 기반의 DBMS 활용이 가능하신 분</li>
                                                <li>Git, Jira등의 소스코드, 이슈 관리 소프트웨어를 사용한 적이 있으신 분</li>
                                                <li>스타트업 초기 멤버로 의욕적으로 회사의 문화를 함께 만들어 가실 분</li>
                                            </ul>
                                            <li class="pt-3"><span class="fkr-set1">우대사항</span></li>
                                            <ul style="margin:0 0 0 -12px">
                                                <li>전산 관련 학과 졸업 후 3년 이상 업계 근무 경력이 있으신 분</li>
                                                <li>AWS와 같은 클라우드 기반 서버 플랫폼에 대한 지식이 있으신 분</li>
                                                <li>Container 기반 개발 환경 구성 경험이 있으신 분</li>
                                                <li>Kubernetes(K8s) 기반 서비스 운영 경험이 있으신 분</li>
                                                <li>건축 분야에 지식이 있거나 관심이 있으신 분</li>
                                                <li>LLM RAG 및 Agent에 대한 지식이 있으신 분</li>
                                                <li>지식을 팀원과 공유하는 것을 즐거워하시는 분</li>
                                                <li>전통적 기술부터 최신 기술까지 다양한 기술 습득을 목표로 하시는 분</li>
                                            </ul>
                                        </ol>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <!-- [혜택 및 복지] / [근무조건] -->
                    <div>
                        <div class="iw-1 py-2 w-100" style="border-bottom:1px solid #e1e1e1">
                            <div class="iw-3 d-flex">

                                <!-- 혜택 및 복지 -->
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span class="fkr-set2 fs-13 fc-w10"><strong>[혜택 및
                                                    복지]</strong></span></div>
                                        <div>
                                            <ul style="margin:0">
                                                <li><span class="fkr-set1 fs-10">리프레시</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2 ">연차, &nbsp;반차, &nbsp;남성출산휴가, &nbsp;시간제 연차</li>
                                                </ul>

                                                <li><span class="fkr-set1 fs-10">급여제도</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">퇴직연금, &nbsp;스톡옵션, &nbsp;퇴직금, &nbsp;4대 보험</li>
                                                </ul>

                                                <li><span class="fkr-set1 fs-10">근무 환경</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">회의실, &nbsp;사내 정원, &nbsp;노트북, &nbsp;사무용품 지급</li>
                                                </ul>

                                                <li><span class="fkr-set1 fs-10">조직 문화</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">자유복장, &nbsp;자유로운 연차사용</li>
                                                </ul>

                                                <li><span class="fkr-set1 fs-10">교육/장학</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">자격이 되는 희망자에 한해, 건축학과 대학원 과정 등록가능 / 등록금 지원.</li>
                                                </ul>
                                                <!-- <li><span class="fkr-set1 fs-10">자유롭고 창의적인 회사</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">자율복장</li>
                                                    <li class="fkr-set2">자율휴가제도</li>
                                                </ul>

                                                <li><span class="fkr-set1 fs-10">일과 삶의 균형</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">업무에 필요한 교육, 세미나, 컨퍼런스, 도서구매 비용 지원</li>
                                                </ul>

                                                <li><span class="fkr-set1 fs-10">자유롭고 창의적인 회사</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">메인 오피스(기흥), 공장(이천)</li>
                                                </ul> -->
                                                <!-- 청년내일채움공제 일몰로 삭제 - DeclanKim 2025.12.02.sprint2 -->
                                                <!-- <li><span class="fkr-set1 fs-10">청년내일채움공제</span></li>
                                                <ul class="pb-3" style="margin:0 0 0 -12px">
                                                    <li class="fkr-set2">업무에 필요한 교육, 세미나, 컨퍼런스, 도서구매 비용 지원</li>
                                                </ul> -->
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="iw-3 d-flex" style="align-items:start;">

                                <!-- 근무조건 -->
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span
                                                class="fkr-set2 fs-13 fc-w10"><strong>[근무조건]</strong></span></div>
                                        <div>
                                            <ul class="pb-3" style="margin:0 0 0 -12px">
                                                <li class="fkr-set2 py-2">채용형태 : 수습기간 3개월 후 정규직 전환(경력에 따라 협의 가능) </li>
                                                <li class="fkr-set2 py-2">급여 : 인센티브제, 회사내규(면접 후 결정)</li>
                                                <li class="fkr-set2 py-2">근무시간 : 주 5일(월 ~ 금) 08:00 ~ 17:00</li>
                                                <li class="fkr-set2 py-2">근무지 : 경기 용인시 기흥구 신갈로 86 </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <!-- [전형절차] / [접수기간 및 방법] -->
                    <div>
                        <div class="iw-1 py-2 w-100" style="border-bottom:1px solid #e1e1e1">
                            <!-- 전형절차 전형절차 변경으로 삭제. - DeclanKim 2025.12.02.sprint2 -->
                            <!-- <div class="iw-3 d-flex" style="align-items:start;">
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span
                                                class="fkr-set2 fs-13 fc-w10"><strong>[전형절차]</strong></span></div>
                                        <div><img src="@/assets/img/s_info/s_info6_1.png" width="100%">

                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="iw-3 d-flex" style="align-items:start;">
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span
                                                class="fkr-set2 fs-13 fc-w10"><strong>[기타사항]</strong></span>
                                        </div>
                                        <div>
                                            <ul class="pb-3" style="margin:0 0 0 -12px">
                                                <li class="fkr-set2 py-2">문의처 : 인사담당자 / 1660-0133 (<a
                                                        href="mailto:recruit@m3.co.kr">recruit@m3.co.kr</a>)</li>
                                                <li class="fkr-set2 py-2">홈페이지 : <a href="https://m3systems.co.kr/"
                                                        target="_blank">https://m3systems.co.kr/</a></li>
                                                <li class="fkr-set2 py-2">블로그 : <a
                                                        href="https://blog.naver.com/m3systems"
                                                        target="_blank">https://blog.naver.com/m3systems</a></li>
                                                <li class="fkr-set2 py-2">인스타그램 : <a
                                                        href="https://www.instagram.com/m3s.korea/"
                                                        target="_blank">https://www.instagram.com/m3s.korea/</a></li>
                                                <li class="fkr-set2 py-2">유튜브 : <a
                                                        href="https://www.youtube.com/channel/UCM6JVuH0hof0OJFq1ivrucA"
                                                        target="_blank">https://www.youtube.com/channel/UCM6JVuH0hof0OJFq1ivrucA</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="iw-3 d-flex" style="align-items:start;">
                                <!-- 접수기간 및 방법 -->
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span class="fkr-set2 fs-13 fc-w10"><strong>[접수기간 및
                                                    방법]</strong></span></div>
                                        <div>
                                            <ul class="pb-3" style="margin:0 0 0 -12px">
                                                <li class="fkr-set2 py-2">접수기간 : 수시채용</li>
                                                <li class="fkr-set2 py-2">접수방법 : 제출서류 작성 후 이메일 제출(recruit@m3.co.kr)</li>
                                                <li class="fkr-set2 py-2">제출서류 : 이력서, 포트폴리오(PDF 파일, 30MB를 넘지 아니함)</li>
                                                <li class="fkr-set2 py-2"> <a
                                                        href="https://s3.ap-northeast-2.amazonaws.com/m3.company.com/platform/download/M3%EC%8B%9C%EC%8A%A4%ED%85%9C%EC%A6%88_%EC%9D%B4%EB%A0%A5%EC%84%9C%EB%B0%8F%EC%9E%90%EA%B8%B0%EC%86%8C%EA%B0%9C%EC%84%9C_%EC%96%91%EC%8B%9D.hwp"
                                                        target="_blank"><b><u>지원 양식 다운로드</u></b></a>
                                                </li>
                                                <li class="fkr-set2 py-2">문의처 : 인사담당자 / 1660-0133 (<a
                                                        href="mailto:recruit@m3.co.kr">recruit@m3.co.kr</a>)</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="iw-3 d-flex" style="align-items:start;">

                                <!-- 유의사항 -->
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span
                                                class="fkr-set2 fs-13 fc-w10"><strong>[유의사항]</strong></span></div>
                                        <div>
                                            <ul class="pb-3" style="margin:0 0 0 -12px">
                                                <li class="fkr-set2 py-2">입사지원 서류에 허위사실이 발견될 경우, 채용확정 이후라도 채용이 취소될 수
                                                    있습니다.</li>
                                                <li class="fkr-set2 py-2">보훈대상자 및 장애인은 관련 법률에 의거하여 우대합니다.</li>
                                                <li class="fkr-set2 py-2">해외여행에 결격사유가 있는 경우 지원이 불가합니다.</li>
                                                <li class="fkr-set2 py-2">제출된 서류는 일체 반환하지 않습니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- [기타사항] / [유의사항] -->
                    <!-- <div>
                        <div class="iw-1 py-2 w-100" style="border-bottom:1px solid #e1e1e1"> -->
                    <!-- 전형절차 -->
                    <!-- <div class="iw-3 d-flex" style="align-items:start;">
                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span
                                                class="fkr-set2 fs-13 fc-w10"><strong>[기타사항]</strong></span></div>
                                        <div>
                                            <ul class="pb-3" style="margin:0 0 0 -12px">
                                                <li class="fkr-set2">문의처 : 인사담당자 / 1660-0133 (<a
                                                        href="mailto:ops@m3.co.kr">recruit@m3.co.kr</a>)</li>
                                                <li class="fkr-set2">홈페이지 : https://m3.co.kr</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                    <!-- <div class="iw-3 d-flex" style="align-items:start;">

                                <div class="w-100">
                                    <div class="p-4">
                                        <div class="py-3"><span
                                                class="fkr-set2 fs-13 fc-w10"><strong>[유의사항]</strong></span></div>
                                        <div>
                                            <ul class="pb-3" style="margin:0 0 0 -12px">
                                                <li class="fkr-set2 py-2">입사지원 서류에 허위사실이 발견될 경우, 채용확정 이후라도 채용이 취소될 수
                                                    있습니다.</li>
                                                <li class="fkr-set2 py-2">보훈대상자 및 장애인은 관련 법률에 의거하여 우대합니다.</li>
                                                <li class="fkr-set2 py-2">해외여행에 결격사유가 있는 경우 지원이 불가합니다.</li>
                                                <li class="fkr-set2 py-2">제출된 서류는 일체 반환하지 않습니다.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div> -->

                </div>
                <!-- 인재 채용 쪽에 의미없는 컴포넌트라 제거. - DeclanKim 2025.12.02.sprint2 -->
                <!-- <MenuFooter/> -->
            </div>
        </div>
    </div>
</template>

<script>
import MenuFooter from '@/components/MenuFooter.vue'
export default {
    name: 'MenuCareer',
    components: {
        MenuFooter
    }
}
</script>